/** @format */

import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, REQUEST_CONTEXT, inject } from '@angular/core';

import { CustomHttpHeaders } from '@shared/data-access/enums';
import { Observable } from 'rxjs';

@Injectable()
export class UniversalProxyInterceptor implements HttpInterceptor {
  private readonly requestContext = inject<{
    req?: { protocol?: string };
    SERVER_PORT?: string | number;
  } | null>(REQUEST_CONTEXT, { optional: true });

  private readonly request: { protocol?: string } | undefined = this.requestContext?.req;

  private readonly serverPort?: string | number = this.requestContext?.SERVER_PORT;

  /**
   * @description
   * Function that acts as an Interceptor for all Universal HTTP Requests.  It converts all
   * relative URLs into absolute URLs
   */
  public intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    // Defaulted cloned request, in case nothing is modified
    let clonedRequest = request.clone();

    // Cloned headers
    let headers = clonedRequest.headers;

    /*
     * TODO: HACK UNTIL HTTPCLIENT OPTIONS ARE IMPLEMENTED -- SEE `https://github.com/angular/angular/issues/18155`
     */
    // Check to see if we need to ignore the `X-PROXY-REQUEST` header
    if (
      request.headers.has(CustomHttpHeaders.X_PROXY_REQUEST) &&
      typeof request.headers.get(CustomHttpHeaders.X_PROXY_REQUEST) === 'string'
    ) {
      // Modify the headers accordingly
      headers = headers.delete(CustomHttpHeaders.X_PROXY_REQUEST);

      // Check to see if the request should be proxied
      if (
        request.url.startsWith('http://') ||
        request.url.startsWith('https://') ||
        request.headers.get(CustomHttpHeaders.X_PROXY_REQUEST)?.toLowerCase() !== 'true'
      ) {
        // Send the newly created request with cloned headers
        return next.handle(
          clonedRequest.clone({
            headers,
          }),
        );
      }

      // Build the new absolute base URL
      let absoluteURL = `${this.request?.protocol || 'https'}://localhost`;

      // Check to see if there is a server port
      if (
        typeof this.serverPort !== 'undefined' &&
        this.serverPort !== null &&
        this.serverPort !== '80' &&
        this.serverPort !== 80
      ) {
        absoluteURL += `:${this.serverPort}`;
      }

      // Check to see if the request starts with a forward slash
      if (!request.url.startsWith('/')) {
        // Append the forward slash
        absoluteURL += '/';
      }

      // Append the relative URL to the absolute base URL
      absoluteURL += request.url;

      // Clone the Request with new headers
      clonedRequest = clonedRequest.clone({
        headers,
        url: absoluteURL,
      });
    }

    // Send the newly created request
    return next.handle(clonedRequest);
  }
}
